/**
 * Created by Arif Topcu in 2019
 */

import React, { memo, useMemo } from "react";
import { useSelector } from "react-redux";
import Combobox, { LabelPosition, Size } from "@ls/react-combobox-grid";
import CovarianceType from "state/selections/Constants/CovarianceType";
import { summaryTypeOptionsLegacy } from "state/selections/Constants/SummaryType";
import { selectFactorOptions } from "state/te/selectors";
import { Cell, Grid } from "styled-css-grid";

const covarianceOptions = Object.values(CovarianceType);

const TrackingErrorSelectorComplication = ({ setDefinition, definition }) => {
  const factorOptions = useSelector(selectFactorOptions);

  const [setFactor, setCovarianceType, setSummary] = useMemo(() => {
    return [
      (value) => setDefinition(definition.setFactor(value)),
      (value) => setDefinition(definition.setCovarianceType(value)),
      (value) => setDefinition(definition.setSummary(value)),
    ];
  }, [definition, setDefinition]);

  return (
    <Grid columns={3} gap="4px">
      <Cell>
        <Combobox
          label="Factor:"
          onChange={setFactor}
          options={factorOptions}
          labelPosition={LabelPosition.TOP}
          value={definition.factor}
          placeholder="Select Factor..."
          gridHeight={100}
          size={Size.S}
          variation={0}
        />
      </Cell>
      <Cell>
        <Combobox
          label="Covariance Type:"
          onChange={setCovarianceType}
          options={covarianceOptions}
          labelPosition={LabelPosition.TOP}
          value={definition.covarianceType}
          placeholder="Select Covariance..."
          gridHeight={100}
          size={Size.S}
          variation={0}
        />
      </Cell>
      <Cell>
        <Combobox
          label="Abs/Rel:"
          onChange={setSummary}
          options={summaryTypeOptionsLegacy}
          value={definition.summary}
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={100}
        />
      </Cell>
    </Grid>
  );
};

export default memo(TrackingErrorSelectorComplication);
